import { INodeTemplate } from '@/types/node';
import { Edit } from './edit';
import { Render } from './render';

const template: INodeTemplate = {
  version: 1,
  name: 'Program',
  icon: 'event',
  type: 'program',
  tag: 'setup & tools',
  content: {
    defaultDisplay: 'auto',
    alignment: {
      vertical: 'center',
      horizontal: 'center',
    },
    verticalSpacing: {
      top: '0',
      bottom: 'md',
    },
  },
  override: {
    root: {},
  },
  supports: {
    contexts: ['page'],
    appender: true,
  },
};

export { template, Render, Edit };
